// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___d7c6addfa934e1d1ed1","cls2":"ImpactHubModal-cls2__d68acb4316dbcbc6b68d ImpactHubModal-cls1___d7c6addfa934e1d1ed1"};